export default __webpack_public_path__ + "static/dan-e29d5f2fc08474fda4ab1dea21f2444b.png";